import { useModalMeta } from "@/shared/atoms/useModal";
import useKeyPress from "@/shared/hooks/useKeyPress";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import usePrintReceipt from "@/shared/hooks/usePrintReceipt";
import PrintActions from "../PrintActions/PrintActions";

const PrintReceiptModal = ({ onExit, ...props }: ModalProps) => {
  const [meta] = useModalMeta();
  const { order, customLabel } = meta;

  const printReceipt = usePrintReceipt();
  const { t } = useTranslation("");
  const enter = useKeyPress("Enter");

  useEffect(() => {
    enter && handlePrint();
  }, [enter]);

  const handlePrint = () => {
    printReceipt(
      order.order_information.item_id,
      order.order_information.branch_id,
      0
    );
    onExit();
  };

  if (!order.order_information) {
    return null;
  }

  return (
    <Modal width="60rem" onExit={onExit} {...props}>
      <ModalTitle>{t("posOrders.printOrder")}</ModalTitle>
      {customLabel && <p>{customLabel}</p>}
      <PrintActions
        className="mt-8"
        orderId={order.order_information.item_id}
        branchId={order.order_information.branch_id}
        types={["order", "client"]}
        onPrint={onExit}
      />
      <div className="mt-12 flex justify-end gap-4">
        <Button variant="secondary" type="button" onClick={() => onExit()}>
          {t("close")}
        </Button>
      </div>
    </Modal>
  );
};

export default PrintReceiptModal;
